import { ApiService } from "../../services/api.service";
import { adminPermissionsType, reportDepositType } from "../../types";
import Cookies from "universal-cookie";
import { useEffect, useState, ChangeEvent, useRef, FormEvent } from "react";
import { Typography, Pagination, Divider, Tooltip, IconButton } from "@mui/material";
import PageLoading from "../PageLoading/PageLoading";
import { Link } from "react-router-dom";
import { useOutletContext } from "../../OutletContext";
import { styled } from "@mui/system";
import Swal from "sweetalert2";

const CustomPagination = styled(Pagination)({
    '& .MuiPaginationItem-root': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "rgba(255, 255, 255, .7)", // สีของหน้าที่ไม่ได้เลือก
    },
    '& .Mui-selected': {
        color: localStorage.getItem('theme') === 'light' ? 'black' : "white",
    },
});

const DepositReport = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [countTransactions, setCountTransactions] = useState<number | null>(null);
    const [transactions, setTransactions] = useState<reportDepositType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);

    const context = useOutletContext();
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getAllTransactions();
    }, [page, limit]);

    const getAllTransactions = async () => {
        if(loading)
        {
            return;
        }

        setLoading(true);
        try {
            const service = new ApiService();
            const getTransactions = await service.getReportsDeposit(cookies.get('access_token'), page, limit);
            console.log(getTransactions.data)
            if(getTransactions.data.status_code !== 200)
            {
                return;
            }
            setCountTransactions(getTransactions.data.all_daily_count);
            setTransactions(getTransactions.data.daily);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const handleChangePage = (_e: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            <>
                <div className="col-12 mb-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="border-top">
                                <tr>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Statistics time
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Success count
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Fail count
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Pending count
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Total successful
                                        </Typography>
                                    </th>
                                    <th align="center">
                                        <Typography align="center" fontSize={`0.75rem`} fontWeight={`bold`}>
                                            Total fee
                                        </Typography>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    transactions.length > 0 ? transactions.map((transaction: reportDepositType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            transaction.date
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            parseFloat(String(`${transaction.success_count}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            parseFloat(String(`${transaction.fail_count}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        {
                                                            parseFloat(String(`${transaction.pending_count}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.full_amount_total}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Typography align="center" fontSize={`0.95rem`}>
                                                        ฿{
                                                            parseFloat(String(`${transaction.charge_amount_total}`)).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                        }
                                                    </Typography>
                                                </td>
                                            </tr>
                                        )
                                    }) :
                                        <tr>
                                            <td colSpan={12}>
                                                <Typography align="center" fontSize={`0.95rem`}>
                                                    NOT FOUND TRANSACTIONS
                                                </Typography>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <div className="card p-2">
                        <div className="row g-2">
                            <div className="col-sm-12 col-xl-6" style={{
                                display: 'flex',
                                alignContent: `center`,
                                alignItems: `center`
                            }}>
                                <CustomPagination
                                    count={Math.ceil((countTransactions === null ? 0 : countTransactions) / limit)}
                                    color="primary"
                                    sx={{ color: 'white'}}
                                    onChange={handleChangePage}
                                    page={page}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default DepositReport;